import { useEffect, useState } from "react";
import { ethers } from "ethers";

import { useWeb3React } from "@web3-react/core";
import { formatEther } from "ethers/lib/utils";

import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";

import abiERC721 from "../constants/sourceContract/abi/abiERC721.json";
import abiERC1155 from "../constants/sourceContract/abi/abiERC1155.json";
import { pinJSONIPFS, getCopyUploadLink, updataUnlock } from "./useUpload";
import { saveToken } from "../store/actions/token";
import { getContractAbi, mintBatchERC721APSI } from "../utils";

const useCloneToken = () => {
	const { account, library } = useWeb3React();
	const dispatch = useDispatch();
	const history = useHistory();
	const tokens = useSelector((state) => state.token.items);
	const [tokenCount, setTokenCount] = useState(tokens?.length ?? 0);

	useEffect(() => {
		if (tokenCount === 0) {
			setTokenCount(tokens.length);
		} else if (tokenCount < tokens?.length) {
			history.push(`/contracts/token/${tokens.at(-1)._id}`);
		}
	}, [tokens, history, tokenCount]);

	const mint = async (props) => {
		const {
			previewData,
			setShow,
			setStage,
			setError,
			hideModal,
			contractType,
			contractAddress,
		} = props;

		const data = {
			contractId: previewData.contractId,
			name: previewData.name,
			description: previewData.description,
			price: previewData.price,
			metadataLink: previewData.metadataLink,
			image: previewData.image,
			imageType: previewData.imageType,
			cover: previewData.cover,
			thumbnail: previewData.thumbnail,
			digitalKey: previewData.digitalKey,
			royalties: previewData.royalties,
			amount: previewData.amount,
			attributes: [...previewData.attributes],
		};

		let signer;
		if (library) {
			signer = await library.getSigner();
		}
		setShow(true);
		setStage("upload");

		const response = await fetch(
			`${process.env.REACT_APP_IPFS_HOST}/${previewData.metadataLink}`
		);
		let meta = await response.json();

		let unlockID;

		async function hashCreator(unlockableLink) {
			const { _id, addPath } = await getCopyUploadLink(unlockableLink);
			data.unlockableLink = addPath;
			unlockID = _id;
			meta.external_url = `${process.env.REACT_APP_API_UNLOCK}/${addPath}`;
			let hashMeta = await pinJSONIPFS(meta);
			return hashMeta;
		}
		// ----------------------------------------------------------------------------
		try {
			const hashMetaToken = previewData.digitalKey.value
				? await hashCreator(previewData.unlockableLink)
				: previewData.metadataLink;
			data.metadataLink = hashMetaToken;

			let tokenResponce;
			let erc721apsiIds;
			if (contractType === "ERC721" || contractType === "ERC721UPG") {
				const contract = new ethers.Contract(
					contractAddress,
					abiERC721,
					signer
				);
				setStage("sign");
				tokenResponce = await contract
					.mint(
						hashMetaToken,
						// [],
						// "0x0000000000000000000000000000000000000000000000000000000000000000",
						{ gasLimit: "720000" }
					)
					.catch(() => {
						return null;
					});
			} else if (contractType === "ERC1155" || contractType === "ERC1155UPG") {
				const contract = new ethers.Contract(
					contractAddress,
					abiERC1155,
					signer
				);
				setStage("sign");
				tokenResponce = await contract
					.mint(data.amount, 0, hashMetaToken, { gasLimit: "720000" })
					.catch(() => {
						return null;
					});
			} else if (["ERC721A", "ERC721PSI"].includes(contractType)) {
				const contract = new ethers.Contract(
					contractAddress,
					getContractAbi(contractType),
					signer
				);

				const newData = [meta];
				const { tx, tokenIds } = await mintBatchERC721APSI(
					contract,
					account,
					newData
				);
				tokenResponce = tx;
				erc721apsiIds = tokenIds;
			}

			if (tokenResponce === null) {
				await hideModal();
				return;
			}

			setStage("mint");
			let tokenTxn = await tokenResponce.wait();

			tokenTxn.logs.length > 0 || tokenTxn.events.length > 0
				? setStage("confirm")
				: setError({ message: "Can`t mint token" });

			let tokenID;
			if (contractType === "ERC721" || contractType === "ERC721UPG") {
				tokenID = Number.parseInt(tokenTxn.logs[0].topics[3]);
			} else if (contractType === "ERC1155" || contractType === "ERC1155UPG") {
				tokenID = Number.parseInt(tokenTxn.events[1].args.tokenId._hex);
			} else if (["ERC721A", "ERC721PSI"].includes(contractType)) {
				tokenID = erc721apsiIds[0];
			}

			data.tokenID = tokenID;
			data.gas = (
				tokenTxn.effectiveGasPrice.toNumber() *
				parseFloat(formatEther(tokenTxn.gasUsed._hex))
			).toFixed(8);

			if (data.unlockableLink) {
				updataUnlock(unlockID, tokenID, contractAddress, contractType);
			}
			dispatch(saveToken(data));

			await hideModal();
		} catch (error) {
			setError({ message: error.message });
			await hideModal();
		}
	};
	return { mint };
};

export { useCloneToken };
